import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ForWhom } from './components/ForWhom';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '1436890408218834');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-bg font-body" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <WhatsIncluded data-id="element-4" />
      <ForWhom data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Offer data-id="element-7" />
      <FAQ data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}